module.exports = __webpack_public_path__ + "img/Chery_thumbnail.16949682.png";